<template>
  <div v-if="content.show" class="field" :class="content.errorMessage?'errorBorder':''">
    <p class="text">
      <span>{{content.order}}</span>{{content.title}}
    </p>
    <div class="ui-input-text">
      <input type="text" v-model="otherWords" @change="textChange(content.num)"/>
    </div >
  </div>
</template>
<script>
export default {
  props:{
    content: Object
  },
  data() {
    return {
      otherWords:''
    }
  },
  methods:{
    textChange:function(num){
       this.$emit("listenToChildEvent",this.otherWords,num,6);
    }
  }
}
</script>
<style lang="stylus" scoped>
  .ui-input-text
    width:96%;
    border: 1px solid #d5d5d5;
    margin: 5px auto;
    background-color: #fff;
    padding: 0;
    border-radius: 3px;
    input
      width: 92%;
      background-color: #fff;
      border: none!important;
      border-radius: 5px;
      padding: 8px 10px;
      font-size: 16px;
      display: inline-block;
      margin: 0;
      -webkit-appearance: none;
</style>
